import React from 'react';
import { SummaryCardRow } from './InventoryUIKit';

/**
 * InvoiceSummaryCards
 *
 * Thin, named wrapper around the shared SummaryCardRow atom so every
 * invoice screen (Monthly / Camp / Bag) renders its summary cards through
 * one consistent component, per the component-structure spec.
 *
 * @param {Array<{title, value, icon, accentColor, loading, error, subtitle}>} cards
 */
const InvoiceSummaryCards = ({ cards }) => <SummaryCardRow cards={cards} />;

export default InvoiceSummaryCards;
